import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CONTROL } from '../../../../components';
import { CALCULATOR_TYPE } from '../../../../types';
import { generateRamItems, getDisk, getEip, SpecificationItem } from '../../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var EcsSpecificationItem = {
  GeneralPurpose: 'General-Purpose (ECS)',
  DedicatedGeneralPurpose: 'Dedicated General-Purpose (ECS)',
  MemoryOptimized: 'Memory-optimized (ECS)',
  DiskIntensive: 'Disk-intensive (ECS)',
  UltraHigh: 'Ultra high I/O (ECS)'
};
export var ecsSpecificationItems = [{
  value: EcsSpecificationItem.GeneralPurpose,
  label: 'General-Purpose',
  description: /*#__PURE__*/_jsxs("ul", {
    children: [/*#__PURE__*/_jsx("li", {
      children: "\u0411\u0430\u0437\u043E\u0432\u044B\u0439 \u0441\u0435\u0440\u0432\u0435\u0440"
    }), /*#__PURE__*/_jsx("li", {
      children: "\u041F\u0435\u0440\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0430 \u043F\u043E\xA0\u044F\u0434\u0440\u0430\u043C 1:3"
    }), /*#__PURE__*/_jsxs("li", {
      children: ["\u0414\u043B\u044F \u0431\u0430\u0437\u043E\u0432\u044B\u0445 \u0432\u044B\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0439,", /*#__PURE__*/_jsx("br", {}), "\u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u044E\u0449\u0438\u0445 \u0432\u044B\u0441\u043E\u043A\u043E\u0439 \u043D\u0430\u0433\u0440\u0443\u0437\u043A\u0438"]
    })]
  })
}, {
  value: EcsSpecificationItem.DedicatedGeneralPurpose,
  label: 'Dedicated General-Purpose',
  description: /*#__PURE__*/_jsxs("ul", {
    children: [/*#__PURE__*/_jsx("li", {
      children: "\u0412\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439 \u0441\u0435\u0440\u0432\u0435\u0440 \u0441\xA0\u043C\u0435\u0445\u0430\u043D\u0438\u0437\u043C\u043E\u043C \u0443\u0441\u043A\u043E\u0440\u0435\u043D\u0438\u044F \u0441\u0435\u0442\u0438 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u043F\u043E\u043A\u043E\u043B\u0435\u043D\u0438\u044F \u0438\xA0\u043D\u0430\u0431\u043E\u0440\u043E\u043C \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A \u0438\xA0\u0434\u0440\u0430\u0439\u0432\u0435\u0440\u043E\u0432 \u0434\u043B\u044F \u0431\u044B\u0441\u0442\u0440\u043E\u0439 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043F\u0430\u043A\u0435\u0442\u043E\u0432 (DPDK)"
    }), /*#__PURE__*/_jsx("li", {
      children: "\u0411\u0435\u0437 \u043F\u0435\u0440\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438"
    }), /*#__PURE__*/_jsx("li", {
      children: "\u0414\u043B\u044F \u0432\u044B\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0439 \u0441\xA0\u0432\u044B\u0441\u043E\u043A\u0438\u043C\u0438 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C\u0438 \u043A\xA0CPU"
    })]
  })
}, {
  value: EcsSpecificationItem.MemoryOptimized,
  label: 'Memory-optimized',
  description: /*#__PURE__*/_jsxs("ul", {
    children: [/*#__PURE__*/_jsx("li", {
      children: "\u0421\u0435\u0440\u0432\u0435\u0440 \u0441 \u0443\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u043D\u044B\u043C \u043E\u0431\u044A\u0435\u043C\u043E\u043C \u043F\u0430\u043C\u044F\u0442\u0438 \u043D\u0430\xA0\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435 \u0432\u0438\u0440\u0442\u0443\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u043F\u043E\u043A\u043E\u043B\u0435\u043D\u0438\u044F, \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u044E\u0449\u0438\u0439 \u0432\u044B\u0441\u043E\u043A\u043E\u044D\u0444\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A\xA0\u043F\u0430\u043C\u044F\u0442\u0438"
    }), /*#__PURE__*/_jsx("li", {
      children: "\u0411\u0435\u0437 \u043F\u0435\u0440\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438"
    }), /*#__PURE__*/_jsx("li", {
      children: "\u0414\u043B\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439, \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\xA0\u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0438\u0435 \u043E\u0431\u044A\u0435\u043C\u044B \u0434\u0430\u043D\u043D\u044B\u0445 \u0432\xA0\u043E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0439 \u043F\u0430\u043C\u044F\u0442\u0438"
    })]
  })
}, {
  value: EcsSpecificationItem.DiskIntensive,
  label: 'Disk-intensive',
  description: /*#__PURE__*/_jsxs("ul", {
    children: [/*#__PURE__*/_jsx("li", {
      children: "\u0421\u0435\u0440\u0432\u0435\u0440 \u0441 \u0432\u044B\u0441\u043E\u043A\u043E\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0434\u0438\u0441\u043A\u0430\u043C\u0438 \u0434\u043B\u044F \u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0447\u0442\u0435\u043D\u0438\u044F/\u0437\u0430\u043F\u0438\u0441\u0438 \u0444\u0430\u0439\u043B\u043E\u0432 \u0438 \u0438\u0445\xA0\u043D\u0438\u0437\u043A\u043E\u0439 \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438"
    }), /*#__PURE__*/_jsx("li", {
      children: "\u0411\u0435\u0437 \u043F\u0435\u0440\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438"
    }), /*#__PURE__*/_jsxs("li", {
      children: ["\u0414\u043B\u044F \u0437\u0430\u0434\u0430\u0447, \u0432\xA0\u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0447\u0442\u0435\u043D\u0438\u0435 \u0438/\u0438\u043B\u0438\xA0\u0437\u0430\u043F\u0438\u0441\u044C \u0444\u0430\u0439\u043B\u043E\u0432 \u0431\u043E\u043B\u044C\u0448\u043E\u0433\u043E \u043E\u0431\u044A\u0435\u043C\u0430", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
        children: "\u0422\u0430\u0440\u0438\u0444\u0438\u0446\u0438\u0440\u0443\u044E\u0442\u0441\u044F \u0432\xA0\u0432\u044B\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u043E\u043C (\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u043E\u043C) \u0440\u0435\u0436\u0438\u043C\u0435"
      })]
    })]
  })
}, {
  value: EcsSpecificationItem.UltraHigh,
  label: 'Ultra-high I/O',
  description: /*#__PURE__*/_jsxs("ul", {
    children: [/*#__PURE__*/_jsxs("li", {
      children: ["\u0421\u0435\u0440\u0432\u0435\u0440 \u0441\xA0\u0432\u044B\u0441\u043E\u043A\u043E\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u043C\u0438 NVMe SSD \u0434\u0438\u0441\u043A\u0430\u043C\u0438, \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u044E\u0449\u0438\u0439 \u043F\u043E\u0432\u044B\u0448\u0435\u043D\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E I/O-\u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439 \u0432\xA0\u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0438\xA0\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0443", /*#__PURE__*/_jsx("br", {}), "\u0447\u0442\u0435\u043D\u0438\u044F/\u0437\u0430\u043F\u0438\u0441\u0438 \u0434\u0430\u043D\u043D\u044B\u0445"]
    }), /*#__PURE__*/_jsx("li", {
      children: "\u0411\u0435\u0437 \u043F\u0435\u0440\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438"
    }), /*#__PURE__*/_jsx("li", {
      children: "\u0414\u043B\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u0441\xA0\u043F\u043E\u0432\u044B\u0448\u0435\u043D\u043D\u044B\u043C\u0438 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C\u0438 \u043A\xA0\u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0434\u0438\u0441\u043A\u043E\u0432"
    })]
  })
}];
export var OsItem = {
  Linux: 'Linux',
  Essentials: 'Essentials'
};
export var osItems = [{
  value: OsItem.Linux,
  label: 'Linux'
}, {
  value: OsItem.Essentials,
  label: 'Essentials'
}];
export var ServerGenItem = {
  SkyLake: '3',
  CascadeLake: '6',
  IceLake: '7'
};
export var skyLakeServerGenItem = {
  value: ServerGenItem.SkyLake,
  label: 'Sky Lake'
};
export var cascadeLakeServerGenItem = {
  value: ServerGenItem.CascadeLake,
  label: 'Cascade Lake'
};
export var iceLakeServerGenItem = {
  value: ServerGenItem.IceLake,
  label: 'Ice Lake'
};
export var ecsSpecificationToGenMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, EcsSpecificationItem.GeneralPurpose, [cascadeLakeServerGenItem, iceLakeServerGenItem]), EcsSpecificationItem.DedicatedGeneralPurpose, [skyLakeServerGenItem, cascadeLakeServerGenItem, iceLakeServerGenItem]), EcsSpecificationItem.MemoryOptimized, [skyLakeServerGenItem, cascadeLakeServerGenItem, iceLakeServerGenItem]), EcsSpecificationItem.DiskIntensive, [skyLakeServerGenItem, cascadeLakeServerGenItem]), EcsSpecificationItem.UltraHigh, [skyLakeServerGenItem]);
export var ecsSpecificationGenToCpuMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, EcsSpecificationItem.GeneralPurpose, _defineProperty(_defineProperty({}, ServerGenItem.CascadeLake, [1, 2, 4, 8]), ServerGenItem.IceLake, [1, 2, 4, 8, 16])), EcsSpecificationItem.DedicatedGeneralPurpose, _defineProperty(_defineProperty(_defineProperty({}, ServerGenItem.SkyLake, [2, 4, 8, 12, 16, 24, 32, 60]), ServerGenItem.CascadeLake, [2, 4, 8, 12, 16, 24, 32, 48, 64]), ServerGenItem.IceLake, [2, 4, 8, 12, 16, 24, 32, 48, 64, 96])), EcsSpecificationItem.MemoryOptimized, _defineProperty(_defineProperty(_defineProperty({}, ServerGenItem.SkyLake, [2, 4, 8, 12, 16, 24, 32, 60]), ServerGenItem.CascadeLake, [2, 4, 8, 12, 16, 24, 32, 64]), ServerGenItem.IceLake, [2, 4, 8, 12, 16, 24, 32, 48, 64, 96])), EcsSpecificationItem.DiskIntensive, _defineProperty(_defineProperty({}, ServerGenItem.SkyLake, [4, 8, 16, 24, 32, 48, 56]), ServerGenItem.CascadeLake, [4, 8, 16, 24, 32, 48, 64, 72])), EcsSpecificationItem.UltraHigh, _defineProperty({}, ServerGenItem.SkyLake, [2, 4, 8, 16, 32, 96]));
export var ecsSpecificationGenCpuToRamMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, EcsSpecificationItem.GeneralPurpose, _defineProperty(_defineProperty({}, ServerGenItem.CascadeLake, {
  '1': [1, 2, 4],
  '2': [4, 8],
  '4': [8, 16],
  '8': [16, 32]
}), ServerGenItem.IceLake, {
  '1': [2, 4],
  '2': [4, 8],
  '4': [8, 16],
  '8': [16, 32],
  '16': [32, 64]
})), EcsSpecificationItem.DedicatedGeneralPurpose, _defineProperty(_defineProperty(_defineProperty({}, ServerGenItem.SkyLake, {
  '2': [4, 8],
  '4': [8, 16],
  '8': [16, 32],
  '12': [24, 48],
  '16': [32, 64],
  '24': [48, 96],
  '32': [64, 128],
  '60': [128, 256]
}), ServerGenItem.CascadeLake, {
  '2': [4, 8],
  '4': [8, 16],
  '8': [16, 32],
  '12': [24, 48],
  '16': [32, 64],
  '24': [48, 96],
  '32': [64, 128],
  '48': [96, 192],
  '64': [128, 256]
}), ServerGenItem.IceLake, {
  '2': [8],
  '4': [16],
  '8': [32],
  '12': [48],
  '16': [64],
  '24': [96],
  '32': [128],
  '48': [192],
  '64': [256],
  '96': [384]
})), EcsSpecificationItem.MemoryOptimized, _defineProperty(_defineProperty(_defineProperty({}, ServerGenItem.SkyLake, {
  '2': [16],
  '4': [32],
  '8': [64],
  '12': [96],
  '16': [128],
  '24': [192],
  '32': [256],
  '60': [512]
}), ServerGenItem.CascadeLake, {
  '2': [16],
  '4': [32],
  '8': [64],
  '12': [96],
  '16': [128],
  '24': [192],
  '32': [256],
  '64': [512]
}), ServerGenItem.IceLake, {
  '2': [16],
  '4': [32],
  '8': [64],
  '12': [96],
  '16': [128],
  '24': [192],
  '32': [256],
  '48': [384],
  '64': [512],
  '96': [768]
})), EcsSpecificationItem.DiskIntensive, _defineProperty(_defineProperty({}, ServerGenItem.SkyLake, {
  '4': [32],
  '8': [64],
  '16': [128],
  '24': [192],
  '32': [256],
  '48': [284],
  '56': [560]
}), ServerGenItem.CascadeLake, {
  '4': [16],
  '8': [32],
  '16': [64],
  '24': [96],
  '32': [128],
  '48': [192],
  '64': [256],
  '72': [288]
})), EcsSpecificationItem.UltraHigh, _defineProperty({}, ServerGenItem.SkyLake, {
  '2': [8],
  '4': [16],
  '8': [32],
  '16': [64],
  '32': [128],
  '96': [384]
}));
var shortSpecificationItems = [{
  value: SpecificationItem.HDD,
  label: 'HDD'
}, {
  value: SpecificationItem.SSD,
  label: 'SSD'
}];
var specificationItems = [{
  value: SpecificationItem.HDD,
  label: 'HDD'
}, {
  value: SpecificationItem.SSD,
  label: 'SSD'
}, {
  value: SpecificationItem.ESSD,
  label: 'ESSD'
}];
export var getCpuFrequency = function getCpuFrequency(ecsSpecification, serverGen) {
  switch (ecsSpecification) {
    case EcsSpecificationItem.UltraHigh:
    case EcsSpecificationItem.GeneralPurpose:
      {
        return '2.6';
      }
    case EcsSpecificationItem.DiskIntensive:
      {
        if (serverGen === ServerGenItem.SkyLake) {
          return '3.0';
        }
        return '2.6';
      }
    case EcsSpecificationItem.DedicatedGeneralPurpose:
    case EcsSpecificationItem.MemoryOptimized:
      {
        if (serverGen === ServerGenItem.IceLake) {
          return '2.6';
        }
        return '3.0';
      }
    default:
      {
        return '3.0';
      }
  }
};
var generateCpuGHItems = function generateCpuGHItems(items, frequency) {
  return items.map(function (item) {
    return {
      value: String(item),
      label: "".concat(item, " (").concat(frequency, " GHz)")
    };
  });
};
export var CLOUD_SERVER_FORM_CONFIG = {
  ui: ['ecsSpecification', 'ecsOs', 'nonPartnersAlert', ['ecsCpu', 'ecsRam'], ['ecsGen', 'evsSystemDisk'], ['evsAdditionalDisks'], 'eip'],
  controls: {
    ecsSpecification: {
      type: CONTROL.Carousel,
      accessorKey: 'ecs.specification',
      defaultValue: EcsSpecificationItem.GeneralPurpose,
      items: ecsSpecificationItems,
      decoratorProps: {
        label: 'Тип сервера'
      }
    },
    ecsOs: {
      type: CONTROL.Object,
      ui: [['ecsOs']],
      controls: {
        ecsOs: {
          type: CONTROL.Segmented,
          accessorKey: 'ecs.os',
          defaultValue: OsItem.Linux,
          items: osItems,
          decoratorProps: {
            label: 'Операционная система'
          }
        }
      },
      relateFn: function relateFn(_ref) {
        var calculatorType = _ref.calculatorType;
        if (calculatorType !== CALCULATOR_TYPE.Partners) {
          return {
            visible: false
          };
        }
      }
    },
    nonPartnersAlert: {
      type: CONTROL.Alert,
      uiProps: {
        visible: false,
        description: 'По умолчанию в стоимость расчета входит ОС Linux. Для расчета стоимости виртуальных машин с другими ОС оставьте заявку на консультацию'
      },
      accessorKey: 'default',
      relateFn: function relateFn(_ref2) {
        var calculatorType = _ref2.calculatorType;
        if (calculatorType !== CALCULATOR_TYPE.Partners) {
          return {
            uiProps: {
              visible: true
            }
          };
        }
      }
    },
    ecsCpu: {
      type: CONTROL.SelectSingle,
      accessorKey: 'ecs.cpu',
      defaultValue: '1',
      items: generateCpuGHItems([1, 2, 4, 8], '2.6'),
      decoratorProps: {
        label: 'Количество vCPU, шт',
        labelTooltip: 'Виртуальный процессор'
      },
      watchedControls: {
        ecsSpecification: 'ecs.specification',
        serverGen: 'ecs.gen'
      },
      relateFn: function relateFn(_ref3) {
        var _ecsSpecificationGenT2;
        var ecsSpecification = _ref3.ecsSpecification,
          serverGen = _ref3.serverGen;
        var items = ecsSpecificationGenToCpuMap === null || ecsSpecificationGenToCpuMap === void 0 ? void 0 : (_ecsSpecificationGenT2 = ecsSpecificationGenToCpuMap[ecsSpecification]) === null || _ecsSpecificationGenT2 === void 0 ? void 0 : _ecsSpecificationGenT2[serverGen];
        if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
          return {
            items: generateCpuGHItems(items, getCpuFrequency(ecsSpecification, serverGen))
          };
        }
      }
    },
    ecsRam: {
      type: CONTROL.Segmented,
      accessorKey: 'ecs.ram',
      defaultValue: '1',
      items: generateRamItems([1, 2, 4]),
      decoratorProps: {
        label: 'Объём RAM',
        labelTooltip: 'Оперативная память'
      },
      watchedControls: {
        ecsSpecification: 'ecs.specification',
        serverGen: 'ecs.gen',
        cpu: 'ecs.cpu'
      },
      relateFn: function relateFn(_ref4) {
        var _ecsSpecificationGenC2, _ecsSpecificationGenC3;
        var ecsSpecification = _ref4.ecsSpecification,
          serverGen = _ref4.serverGen,
          cpu = _ref4.cpu;
        var items = ecsSpecificationGenCpuToRamMap === null || ecsSpecificationGenCpuToRamMap === void 0 ? void 0 : (_ecsSpecificationGenC2 = ecsSpecificationGenCpuToRamMap[ecsSpecification]) === null || _ecsSpecificationGenC2 === void 0 ? void 0 : (_ecsSpecificationGenC3 = _ecsSpecificationGenC2[serverGen]) === null || _ecsSpecificationGenC3 === void 0 ? void 0 : _ecsSpecificationGenC3[cpu];
        if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
          return {
            items: generateRamItems(items)
          };
        }
      }
    },
    ecsGen: {
      type: CONTROL.Segmented,
      accessorKey: 'ecs.gen',
      defaultValue: cascadeLakeServerGenItem.value,
      items: [cascadeLakeServerGenItem, iceLakeServerGenItem],
      decoratorProps: {
        label: 'Поколение GEN'
      },
      watchedControls: {
        ecsSpecification: 'ecs.specification'
      },
      relateFn: function relateFn(_ref5) {
        var ecsSpecification = _ref5.ecsSpecification;
        return {
          items: ecsSpecificationToGenMap[ecsSpecification] || []
        };
      }
    },
    evsSystemDisk: getDisk({
      space: {
        accessorKey: 'evs.systemDisk.diskSpace',
        defaultValue: 40,
        uiProps: {
          min: 40,
          max: 1530,
          postfix: 'ГБ'
        }
      },
      specification: {
        accessorKey: 'evs.systemDisk.specification',
        items: specificationItems,
        watchedControls: {
          escSpecification: 'ecs.specification'
        },
        relateFn: function relateFn(_ref6) {
          var escSpecification = _ref6.escSpecification;
          switch (escSpecification) {
            case EcsSpecificationItem.DiskIntensive:
            case EcsSpecificationItem.UltraHigh:
              return {
                items: shortSpecificationItems
              };
            default:
              {
                return undefined;
              }
          }
        }
      }
    }),
    evsAdditionalDisks: {
      type: CONTROL.Array,
      max: 23,
      accessorKey: 'evs.additionalDisks',
      defaultValue: [],
      addText: 'Добавить диск',
      ui: ['disk'],
      controls: {
        disk: getDisk({
          space: {
            accessorKey: 'diskSpace',
            defaultValue: 10,
            uiProps: {
              min: 10,
              max: 32760
            }
          },
          specification: {
            accessorKey: 'specification'
          }
        })
      }
    },
    eip: getEip({
      trafficKey: 'eip.traffic'
    })
  }
};